const MagistratMesureRemoveStyle = {
  bg: "white",
  flexWrap: "wrap",
  width: "100%",
};

export { MagistratMesureRemoveStyle };
